export default "__VITE_ASSET__DEU3V3O___"